import { observer } from "mobx-react";
import ButtonBack from "newApp/components/ButtonBack";
import MainLayout from "newApp/components/layouts/MainLayout";
import OrganizationForm from "newApp/components/OrganizationForm";
import Button from "newApp/kit/components/Button";
import ButtonsContainer from "newApp/kit/components/ButtonsContainer";
import FlexColumn from "newApp/kit/components/FlexColumn";
import H1 from "newApp/kit/components/H1";
import { URL_ADMINISTRATION_ORGANIZATIONS } from "newApp/routing/urls";
import { OrganizationsCreatePageStore } from "newApp/stores/pages/administrations/organizations/OrganizationsCreatePageStore";
import React, { useEffect } from "react";
import { useHistory } from "react-router";

const store = new OrganizationsCreatePageStore();

const OrganizationsCreatePage: React.FC = () => {
  const { push } = useHistory();

  useEffect(() => {
    store.init();
    return () => store.reset();
  }, []);

  const onClickCreate = async () => {
    const result = await store.onCreate();
    if (result) goOnList();
  };

  const goOnList = () => {
    push(URL_ADMINISTRATION_ORGANIZATIONS);
  };

  return (
    <MainLayout>
      <H1>Создание организации</H1>
      <FlexColumn>
        <ButtonBack url={URL_ADMINISTRATION_ORGANIZATIONS}>
          Назад к списку
        </ButtonBack>
        <OrganizationForm {...store.organizationForm} />
        <ButtonsContainer>
          <Button onClick={onClickCreate}>Создать</Button>
          <Button onClick={goOnList} variant="secondary">
            Отменить
          </Button>
        </ButtonsContainer>
      </FlexColumn>
    </MainLayout>
  );
};

export default observer(OrganizationsCreatePage);
